import React, { Component } from 'react'
import { InputGroup } from "reactstrap";
import { inject, observer } from 'mobx-react';

export default class RadioButtonField extends Component {

    constructor(props){
        super(props)
        this.state={
            checkboxValue: !!this.props.ativo
        }

        this.handleClick = this.handleClick.bind(this)
    }

    handleClick(event){
        this.setState({
            checkboxValue: !this.state.checkboxValue
        },() => {
            this.props.onClick(this.state.checkboxValue)
        })
    }

    componentDidUpdate(prevProps){
        //Para algumas páginas é necessário esperar que o valor retornado pelo serviço seja retornado
        //Até lá um valor placeholder pode ter sido incluso ao this.props.ativo
        if(prevProps.ativo !== this.props.ativo){
            this.setState({
                checkboxValue: this.props.ativo
            })
        }
    }

    render() {
        return(
            <InputGroup>
                <div className={`d-flex justify-content-between align-items-center pl-2 pr-2 
                    ${this.props.widthAuto ? "checkboxfield--group-widthauto" : "checkboxfield--group"}
                    ${this.props.className ? this.props.className : ""}`}
                    style={{backgroundColor: this.props.bloqueado ? "#F0F2F5" : "transparent"}}
                    onClick={this.props.onClick}>
                    <label className="mb-0 w-100" htmlFor={this.props.id}>{this.props.label}</label>
                    <input
                        id={this.props.id}
                        type="radio"
                        name={this.props.name}
                        value={this.props.value}
                        onClick={this.props.onClick}
                        onChange={() => {}}
                        disabled={this.props.bloqueado}
                        //checked={this.props.checked}
                        defaultChecked={this.props.checked} 
                        />
                </div>
            </InputGroup>
        )
    }
}



// WEBPACK FOOTER //
// ./src/modules/comum/components/RadioButtonField.js